import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    btnSave: {
        background: "var(--itsm-bg-btn)",
        color: "#fff",
        marginRight: "10px",
        '&:hover': {
            background: "var(--itsm-bg-btn-hover)",
            color: "#fff",
        }
    },
    btnCancel: {
        background: "#FF7700",
        color: "#fff",
        '&:hover': {
            background: "#FF7700",
            color: "#fff",
        }
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    rootTab: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        height: 224,
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
    },
}));